<template>
    <div class="position-relative">
        <div
            class="mb-0 d-flex align-items-center justify-content-between position-relative flex-wrap select-billing-item-wrapper cursor-pointer py-2"
            @click.stop="$refs.billingRadioInput.click()"
            :style="defaultStyles"
        >
            <label
                class="h-100 mb-0 py-2 px-3 d-inline-flex align-items-center justify-content-start cursor-pointer select-billing-item font-weight-normal"
            >
                <input
                    :[`data-user-modal-input-billing-${name}`]="name"
                    type="radio"
                    class="mr-1 vuetiful-form-radio-button cursor-pointer"
                    name="billing"
                    :value="itemValue"
                    @click.stop="onValueChange"
                    :checked="itemValue === value"
                    :disabled="disabled"
                    ref="billingRadioInput"
                    id="billingRadioInput"
                />
                <!-- price string goes here via slot: -->
                <slot></slot>
            </label>

            <div id="select-billing-item-right" class="select-billing-item-right-wrapper h-100 py-2">
                <span class="plan-credit mr-3 font-weight-bold" v-if="planBillingItemCredit"
                    >{{ planBillingItemCredit }} <CoinSVG
                /></span>
                <template v-if="planBillingItem">
                    <span class="font-size-100 select-billing-learn-more-link font-weight-bold pr-3">
                        <span class="font-weight-normal">from</span>
                        {{ '%PRICE%' | trans({ '%PRICE%': priceStringMonthly }) }}
                    </span>
                    <span class="text-muted font-size-100 select-billing-learn-more-link pr-3">
                        <i class="text-muted far fa-user m-l-5"></i>
                        <span>{{ planBillingItemUse }} </span>
                    </span>
                </template>
                <a
                    v-if="enableLearnMore && !isImg2go"
                    :[`data-user-modal-learn-more-toggle-${name}`]="name"
                    class="text-underline cursor-pointer font-size-100 user-select-none white-space-nowrap select-billing-learn-more-link position-relative pr-3"
                    @click.stop.prevent="toggleLearnMore"
                >
                    <span class="position-absolute top-0 left-0" :class="{ 'opacity-0': !showLearnMore }">{{
                        'show less' | trans
                    }}</span>
                    <span :class="{ 'opacity-0': showLearnMore }">{{ 'learn more' | trans }}</span>
                </a>
            </div>
        </div>
        <template v-if="enableLearnMore">
            <Transition name="fade-grow">
                <div
                    :[`data-user-modal-learn-more-info-${name}`]="name"
                    class="border-top px-4 mb-0 rounded-top-0 br-8 position-relative select-billing-learn-more-box w-100 py-3 bg-cheap-white"
                    v-if="showLearnMore"
                >
                    <span
                        :[`data-user-modal-learn-more-close-${name}`]="name"
                        @click.stop.prevent="showLearnMore = false"
                        class="position-absolute top-0 right-0 py-2 px-2 cursor-pointer lh-1 font-size-150"
                        ><span @click.stop.prevent="closeLearnMore">&times;</span></span
                    >
                    <ul class="mb-0 font-size-100 pl-2">
                        <li class="py-1 px-0" v-for="text in learnMoreTexts" v-html="text"></li>
                    </ul>
                </div>
            </Transition>
        </template>
    </div>
</template>

<script>
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { eventBus } from '../../../../../lib/event-bus/event-bus';
import CoinSVG from '../../../../../qaamgo/modules/sat/components/form/icons/CoinSVG.vue';
import { satGlobals } from '../../../../../qaamgo/sat/helper/sat-globals';

const BILLING_ITEM_TOGGLE_LEARN_MORE = 'billing-item-toggle-learn-more';
const TOGGLE_LEARN_MORE = 'toogle-learn-more';

export default {
    name: 'SelectBillingItem',
    mixins: [TransFilter],
    props: {
        disabled: {
            type: Boolean,
            required: true,
        },
        itemValue: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
        enableLearnMore: {
            type: Boolean,
            default: false,
        },
        learnMoreTexts: {
            type: Array,
            default: [],
        },
        planBillingItem: {
            type: Boolean,
            default: false,
        },
        priceStringMonthly: {
            type: String,
            default: '',
        },
        planBillingItemUse: {
            type: String,
            default: '',
        },
        planBillingItemCredit: {
            type: String,
            default: null,
        },
        defaultStyles: {
            type: String,
            default: null,
        },
    },
    created() {
        eventBus.listen(BILLING_ITEM_TOGGLE_LEARN_MORE, (name) => {
            // ignore event if current instance emitted it
            if (this.name === name) {
                return;
            }
            this.showLearnMore = false;
        });
        eventBus.listen(TOGGLE_LEARN_MORE, (name) => {
            if (this.name === name) {
                this.toggleLearnMore();
            }
        });
    },
    methods: {
        onValueChange(event) {
            event.stopPropagation();
            this.$emit('input', event.target.value);
        },
        toggleLearnMore() {
            this.showLearnMore = !this.showLearnMore;
            // close all other info boxes
            eventBus.emit(BILLING_ITEM_TOGGLE_LEARN_MORE, this.name);
        },
        closeLearnMore() {
            this.$emit('closeLearnmore', this.name);
        },
    },
    computed: {
        isImg2go() {
            return satGlobals.getProjectName() === 'Img2Go';
        },
    },
    data() {
        return {
            showLearnMore: false,
        };
    },
    components: { CoinSVG },
};
</script>

<style scoped>
.plan-credit {
    padding: 1px 10px 0px 10px;
    border-radius: 4px;
    background-color: #ffaa00;
    align-items: center;
    display: flex;
    gap: 5px;
}
#select-billing-item-right {
    margin: 0px;
    padding: 0px;
    padding-right: 0px;
}
.select-billing-learn-more-link {
    margin-left: 0px;
    margin-right: 0px;
}
.select-billing-item-wrapper {
    padding-right: 0px;
}

@media (max-width: 480px) {
    .font-size-100 {
        font-size: 0.9rem;
    }
    .select-billing-item-wrapper {
        font-size: 0.8rem;
    }
    #billingRadioInput {
        position: absolute;
        opacity: 0;
    }
}
</style>
